export interface ConfirmDialogOptions {
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: 'danger' | 'warning' | 'primary';
}

interface ConfirmDialogDetail extends ConfirmDialogOptions {
  message: string;
  resolve: (confirmed: boolean) => void;
}

export const CONFIRM_DIALOG_EVENT = 'pisa:confirm-dialog';

export const confirmDialog = (message: string, options: ConfirmDialogOptions = {}) =>
  new Promise<boolean>((resolve) => {
    window.dispatchEvent(new CustomEvent<ConfirmDialogDetail>(CONFIRM_DIALOG_EVENT, {
      detail: { message, resolve, ...options }
    }));
  });

export type { ConfirmDialogDetail };
